<template>
  <div class="file_block">
    <p class="little-large-bold_label">ファイルの送信</p>
    <p class="strong_label">※アップロードしてから30日後に自動的に削除されるので、ご注意ください。</p>
    <FileUploaderBox
      :document-urls="documentUrls"
      @deleteDocumentUrl="removeDocumentUrls"/>
    <button class="orange-ellipse_button" @click="updateWork()">アップロード</button>

    <p class="little-large-bold_label">ファイルのダウンロード</p>
    <FileDownloaderBox v-for="(registeredDocumentUrl, index) in registeredDocumentUrls" :documentUrl="registeredDocumentUrl" :key="index" />
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import FileDownloaderBox from "@/components/molecules/box/form/FileDownloaderBox";
  import FileUploaderBox from "@/components/molecules/box/form/FileUploaderBox";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import moment from "moment";

  export default {
    name: "FileBlock",

    components: {FileUploaderBox, FileDownloaderBox},

    mixins: [collection],

    props: {
      workId: {
        type: String,
        required: true
      },
      registeredDocumentUrls: {
        type: Array,
        required: true
      },
    },

    data() {
      return {
        documentUrls: []
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    methods: {
      async updateWork() {
        this.registeredDocumentUrls.push(...this.documentUrls);

        const work = await this.getDoc(COLLECTION_NAMES.WORKS, this.workId)

        const requestParams = {
          deadline: moment.unix(work.deadline.seconds).toDate(),
          documentUrls: this.registeredDocumentUrls
        };

        await this.updateDoc(
          COLLECTION_NAMES.WORKS,
          this.workId,
          requestParams
        ).then(() => {
          this.showSuccessMessage('ファイルをアップロードしました。');
          this.documentUrls.splice(0, this.documentUrls.length);
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      removeDocumentUrls(index) {
        this.documentUrls = this.documentUrls.filter((documentUrl, i) => {
          return index !== i;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .file_block {
    display: flex;
    flex-flow: column;
    align-items: flex-end;

    > p {
      margin-bottom: 1rem;
    }
    > .orange-ellipse_button {
      margin: 2rem 0;
    }
    > p, > .file-uploader_box, > .file-downloader_box {
      width: 100%;
    }
  }
</style>